import CustomButton from "components/CustomButton/CustomButton";
import DialogAlertAction from "components/DialogAlertAction/DialogAlertAction";
import { useNavigatingAway } from "utils/hooks/usePrompt";

const DialogNotificationLeaveViewInSync = ({
    canShowDialogLeavingView, content
}) => {
    const [
        showDialogLeavingView,
        confirmNavigation,
        cancelNavigation
    ] = useNavigatingAway(canShowDialogLeavingView);
    return (
        <DialogAlertAction
            variant="secondary"
            show={showDialogLeavingView}
            toggleShow={cancelNavigation}
            title="¿Deseas salir sin finalizar la sincronización?"
            widthContent="90%"
            width="600px"
            contentComponent={content}>
            <CustomButton
                variant="quintinary"
                text="Sí, salir"
                width="130px"
                onClick={confirmNavigation}/>
            <CustomButton
                variant="quaternary"
                text="No, continuar"
                width="130px"
                onClick={cancelNavigation}/>
        </DialogAlertAction>
    );
}

export default DialogNotificationLeaveViewInSync;